enum AnswerTypeEnum {
  Child = "Child",
  Parent = "Parent",
  ParentII = "ParentII",
}

export default AnswerTypeEnum;
